<script setup lang="ts">
import AppInput from '@/shared/ui/AppInput/index';

const emit = defineEmits<{
  (e: 'input', value: string): void;
  (e: 'clear'): void;
}>();

const querySearch: Ref<string> = ref('');

const inputSearchHandler = (): void => {
  emit('input', querySearch.value);
};

const clearSearchHandler = (): void => {
  querySearch.value = '';
  emit('clear');
};
</script>

<template>
  <div class="journal-search">
    <div class="journal-search__search">
      <AppInput
        v-model="querySearch"
        placeholder="Поиск по рубрике, ключевому слову"
        type="text"
        data-testid="journal-search-input"
        @input="inputSearchHandler"
      />
      <button
        :key="querySearch"
        :class="[
          'journal-search__button',
          { _search: !querySearch, '_clear-search': querySearch },
        ]"
        type="button"
        aria-label="Поиск по журналу"
        @click.prevent="clearSearchHandler"
      >
        <AppIcon :name="!querySearch ? 'Search' : 'Cross'" />
      </button>
    </div>
  </div>
</template>

<style lang="less">
.journal-search {
  position: relative;
  max-width: 875px;

  &__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    min-width: @size-x6;
    min-height: @size-x6;

    &._search {
      top: 50%;
      right: @size-x4;
      transform: translateY(-50%);
      pointer-events: none;

      .app-icon {
        width: @size-x5;
        height: @size-x5;

        path {
          fill: @color-elephant;
        }
      }
    }

    &._clear-search {
      top: 50%;
      right: @size-x5;
      transform: translateY(-50%);

      .app-icon {
        width: @size-x3;
        height: @size-x3;
      }
    }
  }
}
</style>
